import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MobileWebViewService} from '../../../core/services/mobile-web-view.service';
import {MobileAppHeader, MobileHeader} from '../../../core/models/onboarding/onboarding-v2-model';
import {CustomTimelineVersion} from '../../model/kamonal-model';

@Component({
	selector: 'app-mobile-timeline-template-v2',
	templateUrl: './mobile-timeline-template-v2.component.html',
	styleUrls: ['./mobile-timeline-template-v2.component.scss']
})
export class MobileTimelineTemplateV2Component implements OnInit {

	@Input() total: number;
	@Input() currentStep: number;
	@Input() previous = 'Go Back';
	@Output() goBack = new EventEmitter();
	@Input() title: string;
	@Input() description: string;
	@Input() disable: boolean;
	@Input() wrapperClass = '';
	@Input() headerClass = '';
	isWebAppUser: boolean;
	readonly mobileHeader = MobileHeader;
	readonly mobileAppHeader = MobileAppHeader;
	@Input() version = CustomTimelineVersion.version_1;
	@Input() showBackButton = true
	CustomTimelineVersion = CustomTimelineVersion;

	constructor(private mobileService: MobileWebViewService) {
	}

	ngOnInit(): void {
		this.isWebAppUser = this.mobileService.isMobileWebViewUser();
	}

	ngOnChanges() {
		console.log("current step",this.currentStep)
	}


	previousRoute() {
		if (this.disable) {
			return;
		}
		this.goBack.emit();
	}

}
